"use strict";

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SunburstChartGenerator = exports.DEFAULT_CONFIG_SUNBURST = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _core = require("@material-ui/core");
var _reactVis = require("react-vis");
var _excluded = ["data"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var DEFAULT_CLASSES = (0, _core.makeStyles)({
  label: {
    fontSize: '12px',
    textAnchor: 'middle',
    textAlign: 'center',
    fill: function fill(props) {
      return props && props.textColor ? props.textColor : 'black';
    },
    fontFamily: function fontFamily(props) {
      return props && props.fontFamily ? props.fontFamily : 'Nunito';
    },
    '& text': {
      fill: function fill(props) {
        return props && props.textColor ? props.textColor : 'black';
      },
      textAnchor: 'middle'
    }
  },
  widgetContainer: {
    marginTop: function marginTop(props) {
      return props && props.titleLocation === 'top' ? '0px' : '18px';
    },
    marginBottom: function marginBottom(props) {
      return props.titleLocation === 'top' ? '18px' : '0px';
    }
  },
  title: {
    color: function color(props) {
      return props && props.textColor ? props.textColor : 'black';
    },
    fontSize: '12px',
    fontFamily: 'Nunito',
    lineHeight: '20px',
    fontWeight: 500,
    height: '20px',
    textAlign: function textAlign(props) {
      return props && props.titleAlignment ? props.titleAlignment : 'center';
    }
  }
});
var DEFAULT_CONFIG_SUNBURST = {
  // Styles used by the component and its children
  styles: {
    textColor: 'black',
    sunburst: {
      stroke: '#ddd',
      strokeOpacity: 0.3,
      strokeWidth: '0.5'
    }
  }
};

/**
 * Recursively finds the node path to the root element
 *
 * @param {*} node
 * @returns array of node titles
 */
exports.DEFAULT_CONFIG_SUNBURST = DEFAULT_CONFIG_SUNBURST;
function getKeyPath(node) {
  if (!node.parent) {
    return ['root'];
  }
  return [node.data && node.data.title || node.title].concat(getKeyPath(node.parent));
}

/**
 * Recursively highlights the node and its children
 *
 * @param {object} d selected child node
 * @param {*} keyPath
 * @returns {object} data with node highlighted
 */
function highlightNode(d, keyPath) {
  var data = d;
  if (data.children) {
    data.children.map(function (child) {
      return highlightNode(child, keyPath);
    });
    data.style = _objectSpread(_objectSpread({}, data.style), {}, {
      fillOpacity: keyPath && !keyPath[data.title] ? 0.2 : 0.7
    });
  } else {
    data.style = _objectSpread(_objectSpread({}, data.style), {}, {
      fillOpacity: keyPath && !keyPath[data.title] ? 0.2 : 1
    });
  }
  return data;
}

/**
 * Find the number of cases in the dataset given the case title
 *
 * @param {object} dataset
 * @param {string} title
 * @returns {number} number of cases
 */
function findCaseCountByTitle(dataset, title) {
  if (title === '') {
    return dataset.children.reduce(function (a, c) {
      return a + c.caseSize;
    }, 0);
  }
  if (dataset.title !== title) {
    if (dataset.children) {
      var match = 0;
      dataset.children.forEach(function (d) {
        var res = findCaseCountByTitle(d, title);
        if (res !== 0) {
          match = res;
        }
      });
      return match;
    }
    return 0;
  }
  return dataset.caseSize;
}

/**
 * Handle mouse over event for the SunburstChart component
 *
 * @param {object} node hovered node object
 * @param {object} data current chart data
 * @param {function} setState react hook to set state
 * @param {function} callback callback function
 */
function valueMouseOver(node, data, setState, callback) {
  var path = getKeyPath(node).reverse();
  var pathAsMap = path.reduce(function (res, row) {
    res[row.toString()] = true;
    return res;
  }, {});
  setState({
    data: callback(data, pathAsMap),
    title: node.title,
    caseSize: node.size || node.caseSize
  });
}

/**
 * Exposes a Sunburst component with the defined configuration
 *
 * @param {object|null} uiConfig
 * @returns {object}
 */
var SunburstChartGenerator = function SunburstChartGenerator() {
  var uiConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_CONFIG_SUNBURST;
  var styles = uiConfig.styles;
  return {
    SunburstChart: function SunburstChart(_ref) {
      var data = _ref.data,
        props = _objectWithoutProperties(_ref, _excluded);
      var titleLocation = props.titleLocation,
        width = props.width,
        height = props.height,
        padAngle = props.padAngle,
        sliceTitle = props.sliceTitle;
      var classes = uiConfig && uiConfig.classes && typeof uiConfig.classes === 'object' ? uiConfig.classes : DEFAULT_CLASSES(_objectSpread(_objectSpread({}, props), styles));
      var _ref2 = (0, _react.useState)({
          data: data,
          title: '',
          caseSize: findCaseCountByTitle(data, '')
        }),
        _ref3 = _slicedToArray(_ref2, 2),
        state = _ref3[0],
        setState = _ref3[1];
      var refHook = (0, _react.useRef)(data);
      (0, _react.useEffect)(function () {
        if ((0, _lodash.isEqual)(refHook.current, data) === false) {
          refHook.current = data;
          setState({
            data: data,
            title: '',
            caseSize: findCaseCountByTitle(data, '')
          });
        }
      }, [data]);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.widgetContainer
      }, titleLocation === 'top' && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.title
      }, state.title), /*#__PURE__*/_react.default.createElement(_reactVis.Sunburst, {
        data: state.data,
        height: height,
        width: width,
        cy: "50%",
        cx: "50%",
        colorType: "literal",
        hideRootNode: true,
        animation: true,
        style: styles && styles.sunburst ? styles.sunburst : DEFAULT_CONFIG_SUNBURST.styles.sunburst,
        onValueMouseOver: function onValueMouseOver(node) {
          return valueMouseOver(node, state.data, setState, highlightNode);
        },
        padAngle: padAngle
      }, state.caseSize > 0 && /*#__PURE__*/_react.default.createElement(_reactVis.LabelSeries, {
        className: classes.label,
        data: [{
          x: 0,
          y: 0,
          label: state.caseSize
        }, {
          x: 0,
          y: 1,
          label: sliceTitle
        }]
      })), titleLocation === 'bottom' && /*#__PURE__*/_react.default.createElement("div", {
        className: classes.title
      }, state.title));
    }
  };
};
exports.SunburstChartGenerator = SunburstChartGenerator;
var _default = SunburstChartGenerator;
exports.default = _default;